export enum Queries {
  GetData = "get-data",
}
